import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
  const auth = getAuth();
  const user = auth.currentUser;

  // If user is not logged in, redirect to login page
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Allow access to /admin/dashboard for the specific user
  if (user.email === 'elshodbekmuxtorov44@gmail.com') {
    return children; // Show the children components (e.g., AdminDashboard)
  }

  // If not the specific user, redirect to home
  return <Navigate to="/home" />;
};

export default ProtectedRoute;
